//Vista de historico de visitas 


// Imports 
import React from 'react';
import {Table, Col, Row, Input, Breadcrumb, Card, Button, Modal, Divider, DatePicker, Spin} from "antd";
import {CloseCircleTwoTone} from '@ant-design/icons';
import axios from 'axios';
//import ReactHTMLTabletoExcel from 'react-html-table-to-excel';
import ExportJsonExcel from "js-export-excel"

const {Search} = Input;
const {RangePicker} = DatePicker;


//Componente HistoricalVisitors
class HistoricalVisitors extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: "",
            dataUser: "",
            dateRange: "",
            visitaSinCargar: true,
            modalGetDataError: false,
            searchValue: "",
            isExportarExcel: false,
            //Total number
            total: 0,
            //Define query parameters
            query: {
                pageNumber: 1,
                pageSize: 10
            }
        }
    };
    //Función que se corre al cargar el componente
    getList = () => {
        //Necesitamos los nombres de los organismos
        // getOrganismos().then((response_org) => {
        //     this.setState({organismos: response_org.data});
        this.setState({visitaSinCargar: true,searchValue: this.state.searchValue,dateRange: this.state.dateRange,query: {pageNumber:this.state.query.pageNumber,pageSize:this.state.query.pageSize}});
        if(window.Roles !== null){
            // getOrganismosRepart(window.Roles[0].code).then(response_repart => {
            //     this.setState({dataUser: response_repart.data[0]});
                //Tomamos todas las solicitudes de visita que nos entrega la api
            axios.post(window.ENV.API_URL + '/mis_solicitudes_historico/',{
                    page_number: this.state.query.pageNumber,
                    page_size: this.state.query.pageSize,
                    key_find: this.state.searchValue,
                    fecha_vigencia: {desde:this.state.dateRange[0], hasta:this.state.dateRange[1]}
                }, {
                    headers: {
                        Authorization: window.Token
                    }
                })
                .then((response_visit) => {
                    //Solo vamos a mostrar las que esten aprobadas
                    // console.log(response_visit.data)
                    // console.log(response_visit.data.data)
                    if (response_visit.data.data == null) {
                        response_visit.data.data = []
                    }
                    const visitasF = response_visit.data.data.map(info => {
                        info.vigencia = {"fecha_inicio": info.VIGENCIA.INICIO,"fecha_termino": info.VIGENCIA.TERMINO}
                        return {...info, key: info.id}
                    });
                    this.setState({data: visitasF,visitaSinCargar: false, total: response_visit.data.pagination.count})
                    return visitasF
                }).catch((error) => {
                    // alert("There is an error in API call.");
                    this.setState({visitaSinCargar : false});
                    this.setState({modalGetDataError: true});
                    return
                });
            // });
        }
        // });
    };
    
    //Llamamos a la funcion anterior
    componentDidMount() {
        this.getList();
    };

    componentDidUpdate(prevProps, prevState) {
      // Uso tipico (no olvides de comparar las props):
      if (this.state.data !== prevState.data && this.state.isExportarExcel) {
        console.log("cambio la data");
        var data = this.state.data ? this.state.data : '';
        var option = {};
        let dataTable = [];
        if (data) {
            for (let i in data) {
                if (data) {
                    let obj = {
                        'Identificación Legal': `${data[i].RUT_PASAPORTE}`,
                        'Nombre': `${data[i].NOMBRE}`,
                        'Fecha de la Solicitud': `${data[i].FECHA_CREACION}`,
                        'Vigencia inicio': `${data[i].VIGENCIA.INICIO}`,
                        'Vigencia término': `${data[i].VIGENCIA.TERMINO}`,
                        'Repartición': `${data[i].ORGANISMO.REPARTICION.nombre}`,
                        'Organismo': `${data[i].ORGANISMO.ORGANISMO.nombre}`,
                        'Departamento': `${data[i].ORGANISMO.DEPARTAMENTO.nombre}`,
                        'Tipo Visita': `${data[i].TIPO_VISITA}`,
                    }
                    dataTable.push(obj);
                }
            }
        }

        option.fileName = 'Solicitudes_Historicas'
        option.datas = [
            {
                sheetData: dataTable,
                sheetName: 'sheet',
                sheetFilter: ['Identificación Legal', 'Nombre', 'Fecha de la Solicitud', 'Vigencia inicio', 'Vigencia término', 'Repartición', 'Organismo', 'Departamento', 'Tipo Visita'],
                sheetHeader: ['Identificación Legal', 'Nombre', 'Fecha de la Solicitud', 'Vigencia inicio', 'Vigencia término', 'Repartición', 'Organismo', 'Departamento', 'Tipo Visita'],
            }
        ];

        var toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
        this.state.isExportarExcel = false;
      }
    }


    downloadExcel = () => {
        this.state.query.pageNumber = 1;
        this.state.query.pageSize = 4000;
        this.getList();
        this.state.isExportarExcel = true;
    }


    handleonChangeDateRange = (value, dateString) => {
        this.setState({dateRange: dateString});
    }

    handleChangeSearch = (e) => {
        this.setState({searchValue: e.target.value, query: {pageNumber:1,pageSize:this.state.query.pageSize}});
    }

    render() {

        function parseRut(rutP){
            if(rutP != null){

                let flag_0 = 0;
                let rut_data = rutP;
                let rutPasaporte = '';

                if(rut_data[0] != 'P'){
                    for (let i = 0; i < rut_data.length; i++) {
                        if(rut_data[i] != 0){
                            flag_0 = 1;
                        }

                        if(flag_0 == 1){
                            if(i < rut_data.length-1){
                                rutPasaporte = rutPasaporte + rut_data[i]
                            }else{
                                rutPasaporte = rutPasaporte + '-' + rut_data[i]
                            }
                        }
                    }
                }else{
                    rutPasaporte = rut_data;
                }

                return rutPasaporte;
            }
        }

        //Data para la tabla
        const columns = [
            {
                title: <label className='prorroga-title'>Rut/Pasaporte</label>,
                dataIndex: "",
                render: text => <label className='prorroga-body-data'>{parseRut(text.RUT_PASAPORTE)}</label>,
                width: "8%"
            },
            {
                title: <label className='prorroga-title'>Nombre</label>,
                dataIndex: "",
                render: text => <label className='prorroga-body-data'>{text.NOMBRE}</label>,
                width: "10%"
            },
            {
                title: <label className='prorroga-title'>Fecha de Ingreso</label>,
                dataIndex: "",
                render: text => <label className='prorroga-body-data'>{text.FECHA_CREACION.substring(8,10) + '-' + text.FECHA_CREACION.substring(5,7) + '-' + text.FECHA_CREACION.substring(0,4)}</label>,
                width: "10%"
            },
            {
                title: <label className='prorroga-title'>Inicio</label>,
                dataIndex: "",
                render: text => <label className='prorroga-body-data'>{text.VIGENCIA.INICIO.substring(8,10) + '-' + text.VIGENCIA.INICIO.substring(5,7) + '-' + text.VIGENCIA.INICIO.substring(0,4)}</label>,
                width: "12%"
            },
            {
                title: <label className='prorroga-title'>Término</label>,
                dataIndex: "",
                render: text => <label className='prorroga-body-data'>{text.VIGENCIA.TERMINO.substring(8,10) + '-' + text.VIGENCIA.TERMINO.substring(5,7) + '-' + text.VIGENCIA.TERMINO.substring(0,4)}</label>,
                width: "10%"
            },
            {
                title: <label className='prorroga-title'>Repartición</label>,
                dataIndex: "",
                render: text => <label className='prorroga-body-data'>{text.ORGANISMO.REPARTICION.nombre}</label>,
                width: "10%"
            },
            {
                title: <label className='prorroga-title'>Organismo</label>,
                dataIndex: "",
                render: text => <label className='prorroga-body-data'>{text.ORGANISMO.ORGANISMO.nombre}</label>,
                width: "15%"
            },
            {
                title: <label className='prorroga-title'>Departamento</label>,
                dataIndex: "",
                render: text => <label className='prorroga-body-data'>{text.ORGANISMO.DEPARTAMENTO.nombre}</label>,
                width: "15%"
            },
            {
                title: <label className='prorroga-title'>Tipo Visita</label>,
                dataIndex: "",
                render: text => <label className='prorroga-body-data'>{text.TIPO_VISITA}</label>,
                width: "10%"
            },
        ];


        return (
            <div>
                <div>
                    <Modal visible={this.state.modalGetDataError} width={600} style={{textAlign: 'center', color: '#d1bd00'}} closeIcon=' ' footer={null}>
                        <CloseCircleTwoTone style={{fontSize: "49px"}}twoToneColor="#FF4D4F"/>
                            <div style={{color:"#47525E", fontSize: "20px", marginTop: "10px"}}>Ocurrio un error obteniendo la información</div>
                        <Divider style={{background: '#969FAA'}}/>
                        <div style={{textAlign: 'right'}}>
                            <Button className='global-principal-button' onClick={event => window.location.href='/'} >ACEPTAR</Button>
                        </div>
                    </Modal>
                </div>
                <Spin tip="Cargando Datos…" spinning={this.state.visitaSinCargar}>
                <Breadcrumb>
                    <Breadcrumb.Item>
                        <a href="/main">Menú principal</a>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>Histórico de visitas</Breadcrumb.Item>
                </Breadcrumb>

                <Card>
                    <Row>
                        <Col span={21}>
                            <div style={{fontSize:"25px", color:"#1978B8"}}><b>Histórico de Visitas</b></div>
                        </Col>
                    </Row>
                    <Row>
                        <Input className="search-input" style={{margin: 10}} placeholder="Buscar por palabras claves para Rut, Nombre, Organismos o Tipo de Visita" onBlur={this.handleChangeSearch}/>
                        <RangePicker style={{borderRadius: 4, margin: 10}} onChange={this.handleonChangeDateRange} placeholder={["Inicio", "Término"]}/>
                        <Button className="global-principal-button" style={{margin: 10}} onClick={() => this.getList()}>BUSCAR</Button>
                        <Button className="global-secundario-button" style={{margin: 10}} onClick={this.downloadExcel}>EXPORTAR A EXCEL</Button>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Table columns={columns} dataSource={this.state.data}
                             // Add paging component
                            pagination={{
                                // Set the total number
                                total: this.state.total,
                                // Option to set page number
                                pageSizeOptions: ["5","10", "20", "50"],
                                //pageSize: this.state.query.pageSize,
                                // display the total number
                                showTotal: total => `Total ${total} visitas`,
                                // Is it possible to change pageSize
                                showSizeChanger: true,
                                current: this.state.query.pageNumber,
                                // When changing the page number
                                onChange: ((page, pageSize) => {
                                    // this.state.visitaSinCargar = true;
                                    this.setState({
                                        query: {
                                            pageNumber: page,
                                            pageSize: pageSize
                                        }
                                    }, () => {
                                        this.getList()
                                    })
                                }),
                                // callback for pageSize change
                                onShowSizeChange: (page, pageSize) => {
                                    // this.state.visitaSinCargar = true;
                                    this.setState({
                                        query: {
                                            pageNumber: page,
                                            pageSize: pageSize
                                        }
                                    }, () => {
                                        this.getList()
                                    })
                                }
                            }}
                            />
                        </Col>
                    </Row>
                </Card>
                </Spin>
            </div>
        );
    }
}

export default HistoricalVisitors;